import { lazy } from 'react';

const TermsAndConditions = lazy(() => import('./TermsAndConditions'));;

export default {
    TermsAndConditions
}
